import React from 'react'
import { Link } from 'gatsby'
import SearchBox from '../searchbox/SearchBox';

import "../../scss/NavigationBar.scss"
import style from "./navigation.module.scss"

function NavigationBar(props) {
  const { siteNav } = props;

  const renderLinkElement = ({ linkName, linkPath }) => (
    <Link id='nav_link' tabIndex={0} to={linkPath} className={style["main-menu"]}>
      {linkName}
    </Link>
  )

  const renderMenuElement = (menuItems, isChild) => (
    <ul className={isChild ? style["child-menu"] : style["main-menu"]}>
      {menuItems.map((item, i) => {
        const hasChildren = item.link.children?.length > 0 || item.children?.length > 0
        const children = item.link.children || item.children
        return (
          <li key={i} className={`${isChild ? style["children"] : style["element"]} ${style["element-a"]}`}>
            {
              hasChildren ?
                <>
                  <Link id='nav_link' className={hasChildren && style["dropdown"]}>
                    {item.link.linkName}
                  </Link>
                  {renderMenuElement(children, hasChildren)}
                </> :
                renderLinkElement(item.link)
            }
          </li>
        )
      })}
    </ul>
  )

  const renderMenuMobile = (menuItems, isChild) => (
    <ul className={isChild ? style["resp-menu"] : style["resp-main"]}>
      {menuItems.map((item, i) => {
        const hasChildren = item.link.children?.length > 0 || item.children?.length > 0
        const children = item.link.children || item.children
        return (
          <li key={i} className={isChild ? style["resp-child"] : style["resp-elem"]}>
            {
              hasChildren ?
                <>
                  <Link id='nav_link' tabindex={-1} className={hasChildren && style["resp-drop"]}>
                    {item.link.linkName}
                  </Link>
                  {renderMenuMobile(children, hasChildren)}
                </> :
                renderLinkElement(item.link)
            }
          </li>
        )
      })}
    </ul>
  )

  return (
    <header id="header" className={style["header"]}>
      <div className="header site__section js-header">
        <section className="header__section site__subsection">
          <Link className="button button_type-icon header__logo icon_logo js-button nav-logo" to="/">
            <img className="nav-icon" src={props.dealerInfo.dealerLogo} alt={props.dealerInfo.dealerName} />
          </Link>
          <Link className="lotus-font-secondary-title button button_type-icon header__logo js-button text_logo" to="/">
            <span className="lotus-font-secondary-title">{props.dealerInfo.dealerName.substring(0, props.dealerInfo.dealerName.indexOf(" "))}</span>
            {props.dealerInfo.dealerName.substring(props.dealerInfo.dealerName.indexOf(" "), props.dealerInfo.dealerName.length)}
          </Link>
        </section>
        <section className="header__section site__subsection">
          <menu className="menu js-menu">
            <div className="menu__wrapper">
              {renderMenuElement(props.siteNav.menu)}
            </div>
          </menu>
        </section>
        <a onClick={() => toggleMobile()} className="burger header__explore-menu js-header-explore-button">
          <a class="burger header__explore-menu js-header-explore-button">
            <ul class="burger__buns">
              <div class="menu-grid">
                <li class="burger__bun"></li>
                <li class="burger__bun"></li>
                <li class="burger__bun"></li>
              </div>
              <div class="menu-grid">
                <li class="burger__bun"></li>
                <li class="burger__bun"></li>
                <li class="burger__bun"></li>
              </div>
              <div class="menu-grid">
                <li class="burger__bun"></li>
                <li class="burger__bun"></li>
                <li class="burger__bun"></li>
              </div>
            </ul>
          </a>
        </a>

        <SearchBox />
      </div>
      <section className='nav-mobile'>
        <div id="mobileDropDown" className="nav-cont">
          <div className="nav-overflow">
            {renderMenuMobile(props.siteNav.menu)}
          </div>
        </div>
      </section>
    </header>
  )
}

function toggleDrop(id) {
  const div = document.getElementById(id)
  div.classList.toggle('showDrop')
}

function toggleMobile() {
  document.getElementById("mobileDropDown").classList.toggle('showMobile');
  document.getElementsByClassName("header__explore-menu")[0].classList.toggle('state_toggled');
}

export default NavigationBar

